import {
	formatAddOnLineLabel,
	formatModifierLineLabel,
} from '@/helper/cartFamily';

/**
 * Secondary rows under a meal name: add-ons, modifiers, discount note, Note.
 * Matches Cart / Orders density (muted 12px).
 */
export default function MealLineMeta({
	addOns = [],
	modifiers = [],
	note = '',
	discountNote = '',
	as = 'p',
}) {
	const Tag = as === 'small' ? 'small' : 'p';
	const style =
		as === 'small'
			? undefined
			: { fontSize: 12, margin: '2px 0 0' };
	const className = 'muted';
	const rows = [];

	(addOns || []).forEach((addOn, index) => {
		rows.push({
			key: `ao-${addOn?.id ?? addOn?.add_on?.id ?? index}`,
			text: formatAddOnLineLabel(addOn),
		});
	});
	(modifiers || []).forEach((mod, index) => {
		rows.push({
			key: `mod-${mod?.id ?? mod?.modifier?.id ?? index}`,
			text: formatModifierLineLabel(mod),
		});
	});
	if (discountNote) {
		rows.push({ key: 'disc', text: discountNote });
	}
	const noteText = typeof note === 'string' ? note.trim() : '';
	if (noteText) {
		rows.push({ key: 'note', text: `Note: ${noteText}` });
	}

	if (!rows.length) return null;

	return (
		<>
			{rows.map((row) => (
				<Tag key={row.key} className={className} style={style}>
					{row.text}
				</Tag>
			))}
		</>
	);
}
